import React from 'react';

import { capitalize } from 'lodash';
import {
  MdAddCircle,
  MdEdit,
  /*TODO:uncomment when SBL-6710 is fixed
// MdDelete,
*/
} from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import type { RosterTableData } from '@modules/advancement/packRoster/types';
import {
  setSelectedSubUnitId,
  showAddToSubUnitModal,
  showSetSubUnitModal,
} from '@modules/advancement/subUnits/duck/actions';
import { subUnitTypeSel } from '@modules/advancement/subUnits/duck/selectors';
import { Menu } from '@shared/components';

import { setSubUnitUserData } from '../../../../duck';
import styles from './SubUnitMenu.less';

type Props = {
  data: RosterTableData;
  onPress: VoidFunction;
};

export const SubUnitMenu: React.FC<Props> = ({ data, onPress }) => {
  const subUnitTypeName = useSelector(subUnitTypeSel);
  const dispatch = useDispatch();

  /*TODO:uncomment when SBL-6710 is fixed
  // @ts-expect-error: missing native event menu item
  // const handleClickMenuDelete = e => {
  //   onPress();
  //   e.domEvent.stopPropagation();
  //   dispatch(setSubUnitUserData(data));
  // };
  */

  // @ts-expect-error: missing native event menu item
  const handleClickMenuEdit = e => {
    onPress();
    e.domEvent.stopPropagation();
    dispatch(setSelectedSubUnitId(data.subUnitId));
    dispatch(showSetSubUnitModal());
  };

  // @ts-expect-error: missing native event menu item
  const handleClickMenuAdd = e => {
    onPress();
    e.domEvent.stopPropagation();
    dispatch(setSubUnitUserData(data));
    dispatch(showAddToSubUnitModal());
  };

  return data.subUnitId && data.subUnitId > 0 ? (
    <Menu selectable={false} className={styles.menu} subMenuCloseDelay={0}>
      <Menu.Item onClick={handleClickMenuEdit}>
        <MdEdit className={styles.menuIcon} />
        <FormattedMessage
          id="advancement.PackRoster.subUnitMenu.editSubUnit"
          values={{
            subUnitType: capitalize(subUnitTypeName),
          }}
        />
      </Menu.Item>
      {/* TODO:uncomment when SBL-6710 is fixed */}
      {/* <hr />
      <Menu.Item onClick={handleClickMenuDelete}>
        <MdDelete className={styles.menuIcon} />
        <FormattedMessage
          id="advancement.PackRoster.subUnitMenu.deleteSubUnit"
          values={{
            subUnitType: capitalize(subUnitTypeName),
          }}
        />
      </Menu.Item> */}
    </Menu>
  ) : (
    <Menu selectable={false} className={styles.menu} subMenuCloseDelay={0}>
      <Menu.Item onClick={handleClickMenuAdd}>
        <MdAddCircle className={styles.menuIcon} />
        <FormattedMessage
          id="advancement.PackRoster.subUnitMenu.addToSubUnit"
          values={{
            subUnitType: capitalize(subUnitTypeName),
          }}
        />
      </Menu.Item>
    </Menu>
  );
};
